module.exports = __webpack_public_path__ + "img/tp-card-2.5c7ec762.png";